module.exports = __webpack_public_path__ + "img/popover-bg.0f7e9f7.webp";